// @flow
import TeamMenu from 'components/teammenu/TeamMenu';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/teammenu/TeamMenu';
import { fetchTeamList } from 'actions/teamlistActions';
import { STATUS_SUCCESS, STATUS_LOADING } from 'constants/statusConstants';

export default connect(
    (state: StateType): StateProps => ({
      teamlist: [...state.teamlistState.teamlist],
      isHome: true,
      boutique: state.settingsState.boutique,
      status:
        state.teamlistState.status === STATUS_SUCCESS
          ? STATUS_SUCCESS
          : STATUS_LOADING,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchTeamList: () => dispatch(fetchTeamList())
    })
)(TeamMenu);
